//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');

  curalate.directive('trackingParams', () => ({
    restrict: 'E',
    scope: { },
    template: require('@partials/tracking-params/tracking-params.html'),
    controller: 'TrackingParamsController',
    controllerAs: 'ctrl',
  }));
})();
